/**
 * Latest shared mobility report per senior (slug from `POST /v6/report`,
 * `kind: "mobility_report"`), so the Patient Summary can link its
 * "Full Mobility Report" to `/mobility-report-shared/{slug}`.
 *
 * Saved every time the report is shared (MobilityReport.js); the latest share
 * always wins — no report ID or check-date matching. The backend is the
 * cross-device source (`summary.report.slug`); this is the same-device
 * fallback. Public report links expire after 30 days, so older ones are
 * ignored.
 */
const KEY_PREFIX = "seniorlife:mobilityReportSnapshot:";
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

const keyFor = (seniorId) => `${KEY_PREFIX}${seniorId}`;

export const rememberMobilityReportSnapshot = (
  seniorId,
  slug,
  now = Date.now(),
) => {
  if (!seniorId || !slug) return;
  try {
    window.localStorage.setItem(
      keyFor(seniorId),
      JSON.stringify({ slug, createdAt: new Date(now).toISOString() }),
    );
  } catch (error) {
    // Storage unavailable (private mode etc.) — the backend link still applies.
  }
};

/** The latest shared report for the senior, or null when none / expired. */
export const readMobilityReportSnapshot = (
  seniorId,
  { now = Date.now() } = {},
) => {
  if (!seniorId) return null;
  try {
    const value = JSON.parse(
      window.localStorage.getItem(keyFor(seniorId)) || "null",
    );
    if (!value?.slug) return null;
    const created = Date.parse(value.createdAt);
    if (!Number.isFinite(created) || now - created > MAX_AGE_MS) return null;
    return value;
  } catch (error) {
    return null;
  }
};
